import React, {useEffect, useState} from 'react'
import {Button, Form, InputNumber, Modal, AutoComplete, DatePicker, message} from "antd";
import {getAllStock} from "../../../services/serviceStock";
import {createOutgoing} from "../../../services/serviceWarehouseOutgoing";
import {getAllCustomer} from "../../../services/serviceCustomer";
import {getStockInformation} from "../../../services/serviceInventory";
import config from "../../../config";
import {enterLoadingState, exitLoadingState} from "../../../utils/helpers/commonFunctions";


const DEFAULT_OUTGOING = 'NORMAL'
const {Option} = AutoComplete
const formLayout = {
    labelCol: {span: 8},
    wrapperCol: {span: 16}
}

const OutgoingCreate = ({show, modalCloser}) => {
    const [form] = Form.useForm()
    const [stocks, setStocks] = useState([])
    const [selectedStock, setSelectedStock] = useState([])
    const [selectedWarehouse, setSelectedWarehouse] = useState()
    const [warehouseOptions, setWarehouseOptions] = useState([])
    const [selectedOutgoingType, setSelectedOutgoingType] = useState(DEFAULT_OUTGOING)
    const [customers, setCustomers] = useState([])
    const [selectedCustomer, setSelectedCustomer] = useState()
    const [loadings, setLoadings] = useState([])

    useEffect(() => {
        getAllStock()
            .then(({data}) => {
                const stocks = data.map(item => {
                    return {
                        value: item.id,
                        text: `${item.code} - ${item.name}`
                    }
                })
                setStocks(stocks)
            })
    }, [])
    const outgoingOptions = [
        {
            value: 'NORMAL',
            text: 'Normal'
        },
        {
            value: 'CONSIGNED',
            text: 'Konsinye'
        },
        {
            value: 'ERROR',
            text: 'Hatalı İşlem'
        },
        {
            value: 'SHIPPING_ORDER',
            text: 'Sevkiyat Emri'
        }
    ]
    const getCustomers = () => {
        getAllCustomer()
            .then(({data}) => {
                if (data.length) {
                    const customersData = data.map(item => {
                        return {
                            value: item.id,
                            text: `${item.name}`
                        }
                    })
                    setCustomers(customersData)
                } else {
                    message.warning('Sistemde kayıtlı bir müşteri bulunamadı')
                }
            })
    }
    const handleOutgoingTypeChange = (v, {key}) => {
        const isConsigned =  key === 'CONSIGNED'

        if (isConsigned) {
            getCustomers()
        }

        setSelectedOutgoingType(key)
    }
    const handleCustomerSelect = (v, {key}) => setSelectedCustomer(key)
    const handleStockChange = (v, {key}) => {
        if (key) {
            getStockInformation(key)
                .then(({data}) => {
                    const warehouses = data.map(item => {
                        return {
                            value: item.warehouse.id,
                            text: `${item.warehouse.code} - ${item.warehouse.name}`
                        }
                    })
                    setWarehouseOptions(warehouses)
                })
        }
        setSelectedStock(key)
    }
    const handleWarehouseChange = (v, {key}) => setSelectedWarehouse(key)
    const handleSubmit = (list) => {
        enterLoadingState(setLoadings)
        let requestObj = {
            outgoingQuantity: list.outgoingQuantity,
            outgoingType: selectedOutgoingType,
            stock: {
                id: selectedStock
            },
            warehouse: {
                id: selectedWarehouse
            }
        }

        if (selectedOutgoingType === 'CONSIGNED') {
            requestObj.isConsignmentCompleted = true
            requestObj.customer = {id: selectedCustomer}
            requestObj.deliveryDate = list.deliveryDate._d
        }

        createOutgoing(requestObj)
            .then(() => {
                exitLoadingState(setLoadings)
                modalCloser()
            })
            .catch(() => exitLoadingState(setLoadings))
    }

    return (
        <React.Fragment>
            <Modal
                title={'Depo Çıkış Yap'}
                open={show}
                closable={false}
                footer={[
                    <Button type={'primary'}
                            key={'SubmitButton'}
                            onClick={() => form.submit()}
                            loading={loadings[0]}
                    >Kaydet</Button>,
                    <Button key={'CancelButton'} onClick={() => modalCloser()}>Kapat</Button>
                ]}
            >
                <Form
                    {...formLayout}
                    labelAlign={"left"}
                    form={form}
                    onFinish={() => handleSubmit(form.getFieldsValue())}
                >
                    <Form.Item
                        label={"Ürün"}
                        name={"outgoingStock"}
                        rules={[
                            {required: true, message: 'Lütfen Ürün Seçiniz'}
                        ]}
                    >
                        <AutoComplete
                            onChange={handleStockChange}
                            filterOption={(inputValue, option) =>
                                option.value.toUpperCase().indexOf(inputValue.toUpperCase()) !== -1
                            }
                        >
                            {
                                stocks.map(item => {
                                    return (<Option key={item.value} value={item.text}/>)
                                })
                            }
                        </AutoComplete>
                    </Form.Item>
                    {
                        warehouseOptions.length ?
                            <Form.Item
                                label={'Depo'}
                                name={'warehouse'}
                                rules={[
                                    {required: true, message: 'Lütfen Depo Seçiniz'}
                                ]}
                            >
                                <AutoComplete
                                    onChange={handleWarehouseChange}
                                    filterOption={(inputValue, option) =>
                                        option.value.toUpperCase().indexOf(inputValue.toUpperCase()) !== -1
                                    }
                                >
                                    {
                                        warehouseOptions.map(item => <Option key={item.value} value={item.text}/>)
                                    }
                                </AutoComplete>
                            </Form.Item> : null
                    }
                    <Form.Item
                        label={"Miktar"}
                        name={"outgoingQuantity"}
                        initialValue={1}
                        rules={[
                            {required: true, message: 'Miktar Alanı Boş Bırakılamaz'},
                            {type: "number", min: 1, message: 'Miktar Alanı En Az 1 Olmalıdır'}
                        ]}
                    >
                        <InputNumber step={0.1}/>
                    </Form.Item>
                    <Form.Item
                        label={"Çıkış Tipi"}
                        name={"outgoingType"}
                        initialValue={"Normal"}
                        rules={[
                            {required: true, message: 'Lütfen Çıkış Tipi Seçiniz'}
                        ]}
                    >
                        <AutoComplete
                            onChange={handleOutgoingTypeChange}
                            filterOption={(inputValue, option) =>
                                option.value.toLocaleLowerCase().indexOf(inputValue.toLocaleLowerCase()) !== -1
                            }
                        >
                            {
                                outgoingOptions.map(item => {
                                    return (
                                        <Option key={item.value} value={item.text}/>
                                    )
                                })
                            }
                        </AutoComplete>
                    </Form.Item>
                    {
                        selectedOutgoingType === 'CONSIGNED' && customers.length ?
                            <React.Fragment>
                                <Form.Item
                                    label={'Müşteri'}
                                    name={'customers'}
                                    rules={[
                                        {required: true, message: 'Bu Alan boş Bırakılamaz'}
                                    ]}
                                >
                                    <AutoComplete
                                        onChange={handleCustomerSelect}
                                        filterOption={(inputValue, option) =>
                                            option.value.toLocaleLowerCase().indexOf(inputValue.toLocaleLowerCase()) !== -1
                                        }
                                    >
                                        {
                                            customers.map(item => {
                                                return (
                                                    <Option key={item.value} value={item.text}/>
                                                )
                                            })
                                        }
                                    </AutoComplete>
                                </Form.Item>
                                <Form.Item
                                    label={'Tarih'}
                                    name={'deliveryDate'}
                                    rules={[
                                        {required: true, message: 'Bu alan boş bırakılamaz'}
                                    ]}
                                >
                                    <DatePicker format={config.userDateFormat} placeholder={'Tarih seçiniz'}/>
                                </Form.Item>
                            </React.Fragment>
                            : null
                    }
                </Form>
            </Modal>

        </React.Fragment>
    )
}
export default OutgoingCreate